/* Black Honey Coffee — theme JS
   Mobile nav, variant sync, quantity stepper, AJAX add-to-cart. No dependencies. */
(function () {
  'use strict';

  // ---- mobile nav -----------------------------------------------------------
  var burger = document.querySelector('.burger');
  var nav = document.querySelector('.nav');
  if (burger && nav) {
    function setMenu(open) {
      nav.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.textContent = open ? '\u2715' : '\u2630';
      document.documentElement.classList.toggle('nav-open', open);
      document.body.classList.toggle('nav-open', open);
    }
    var closeMenu = function () { setMenu(false); };
    burger.addEventListener('click', function () {
      setMenu(!nav.classList.contains('open'));
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('open') &&
          !e.target.closest('.nav') && !e.target.closest('.burger')) closeMenu();
    });
  }

  // ---- variant sync ---------------------------------------------------------
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var variants = [];
    try { variants = JSON.parse(document.getElementById('variant-json').textContent); }
    catch (e) { variants = []; }

    var selects = form.querySelectorAll('[data-option-index]');
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function sync() {
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.dataset.optionIndex, 10)] = s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();

    // ---- AJAX add-to-cart ---------------------------------------------------
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add]');
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]').value || 1, 10)
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var c = document.querySelector('.cart-count');
          if (c) c.textContent = cart.item_count;
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled = false;
        });
    });
  }

  // ---- quantity stepper -----------------------------------------------------
  document.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      var next = parseInt(input.value || 1, 10) + parseInt(b.dataset.qtyStep, 10);
      input.value = Math.max(1, next);
    });
  });
})();